export default __webpack_public_path__ + "static/media/ForgetPassword.fa4e05ce.svg";